// extracted by mini-css-extract-plugin
module.exports = {"freezescroll":"_3v7EVp","base":"_2Aoruo","overlay":"_2JKnlt","active":"g6AIar","wrapper":"_2982LX","ignoreAnim":"_2mA-BQ","transparent":"_3ahmuH"};